import Loadable from "@loadable/component";

const ProductWebSizes = Loadable(
  () =>
    import(
      /* webpackChunkName: "product_web_sizes_component" */ "./productWebSizes"
    )
);

export default ProductWebSizes;
